export default __webpack_public_path__ + "static/yuri-vasyutinskiy-42c8db57604e87eb81ac2188d27b1888.png";